import { render, staticRenderFns } from "./Flavour.vue?vue&type=template&id=26dec34e"
import script from "./Flavour.vue?vue&type=script&lang=js"
export * from "./Flavour.vue?vue&type=script&lang=js"
import style0 from "./Flavour.vue?vue&type=style&index=0&id=26dec34e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports